/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedMoreWaysToBrowse_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedMobileMoreWaysToBrowse_viewer">;
    readonly " $refType": "BuySharedMoreWaysToBrowse_viewer";
};
export type BuySharedMoreWaysToBrowse_viewer$data = BuySharedMoreWaysToBrowse_viewer;
export type BuySharedMoreWaysToBrowse_viewer$key = {
    readonly " $data"?: BuySharedMoreWaysToBrowse_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedMoreWaysToBrowse_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedMoreWaysToBrowse_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedMobileMoreWaysToBrowse_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'ae12104c23d4c930cf693ab0b1890bc1';
export default node;
